<template>
  <div class="Music">
    <el-tabs v-model="active_name" type="card" @tab-click="handleClick">
      <el-tab-pane label="Music Files" name="first">
        <MusicPlaylist v-if="active_name==='first'"></MusicPlaylist>
      </el-tab-pane>
      <el-tab-pane label="Music Albums" name="second">
        <MusicAlbum v-if="active_name==='second'"></MusicAlbum>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import MusicPlaylist from "@/components/Music/MusicPlaylist/MusicPlaylist";
  import MusicAlbum from "@/components/Music/MusicAlbum/MusicAlbum";


  export default {
    props: {},
    components: {
      MusicPlaylist,
      MusicAlbum
    },
    data: () => {
      return {
        active_name: 'first'
      }
    },
    methods: {
      onListTap() {
        this.active_name = 'first'
      },
      handleClick(tab) {
        this.active_name = tab.paneName
      }
    },
    beforeMount(){
      this.active_name = this.$route.params.target?this.$route.params.target:"first"
    },
  };

</script>
